import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { optAndSubmitContentLinkFailure, optAndSubmitContentLinkSuccess } from '../../actions/InfluencerCampaignActions/optAndSubmitContentLinkActions';

function* optAndSubmitContentLink({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.optAndSubmitContentLink,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("OPT_AND_SUBMIT_CONTENT_LINK_SUCCESS status :", response.data.status);
        console.log("OPT_AND_SUBMIT_CONTENT_LINK_SUCCESS data :", response.data.response);
        console.log("OPT_AND_SUBMIT_CONTENT_LINK_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            optAndSubmitContentLinkSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("OPT_AND_SUBMIT_CONTENT_LINK_FAILURE status :", error?.response?.status);
        console.log("OPT_AND_SUBMIT_CONTENT_LINK_FAILURE data:", error?.response?.data);
        console.log("OPT_AND_SUBMIT_CONTENT_LINK_FAILURE error :", error);
        console.log('====================================');
        yield put(optAndSubmitContentLinkFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
        }
    }

function* optAndSubmitContentLinkSaga() {
    yield takeLatest(actionTypes.OPT_AND_SUBMIT_CONTENT_LINK_REQUEST, optAndSubmitContentLink);
}

export default optAndSubmitContentLinkSaga;
